import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class PushNotificationsService {
  public permission: Permission;
  constructor() {
    this.permission = this.isSupported() ? 'default' : 'denied';
  }
  public isSupported(): boolean {
    return 'Notification' in window;
  }
  requestPermission(): void {
    let self = this;
    if ('Notification' in window) {
      Promise.resolve(Notification.requestPermission()).then(function (status) {
        return (self.permission = status);
      });
      // Notification.requestPermission(function (status) {
      //   return (self.permission = status);
      // });
    }
  }
  create(title: string, options?: PushNotification, url?): any {
    let self = this;
    return new Observable(function (obs) {
      if (!('Notification' in window)) {
        console.log('Notifications are not available in this environment');
        obs.complete();
      }
      if (self.permission !== 'granted') {
        console.log(
          "The user hasn't granted you permission to send push notifications"
        );
        obs.complete();
      }
      let _notify = new Notification(title, options);
      console.log("_notify",_notify)
      _notify.onshow = function (e) {
        return obs.next({
          notification: _notify,
          event: e,
        });
      };
      _notify.onclick = function (e) {
        // console.log('clicked e', e);
        // e.preventDefault(); // prevent the browser from focusing the Notification's tab
        window.open(url ? url :'https://app.mysembra.com/', '_blank', '');

        // clients.matchAll({ type: "window" }).then((windowClients) => {
        // })
        return obs.next({
          notification: _notify,
          event: e,
        });
      };
      _notify.onerror = function (e) {
        return obs.error({
          notification: _notify,
          event: e,
        });
      };
      _notify.onclose = function () {
        return obs.complete();
      };
    });
  }
  generateNotification(source: Array<any>): void {
    let self = this;
    source.forEach((item) => {
      // console.log(item)
      let notificationList: any = localStorage.getItem("notificationPreferences");
      let options = {
        body: item.alertContent,
        icon: 'assets/icons/icon-192x192.png',
        silent: notificationList ? notificationList.indexOf('silentNotifications') > -1 ? true : false : false,
        badge: 'assets/icons/icon-192x192.png',
        android: {
          notification: {
            icon: 'assets/icons/icon-192x192.png',
            color: '#282be0ff'
          }
        },
        image: null
      };
      if (notificationList) {
        if (notificationList.indexOf('silentNotifications') > -1) {
          options.silent = true;
        }

        if ((notificationList.indexOf('ticketNotifications') > -1 && item.title.toLowerCase().indexOf('new thread') > -1)
          || (notificationList.indexOf('ticketNotificationsUpdate') > -1 && item.title.toLowerCase().indexOf('thread linked') > -1)
          || (notificationList.indexOf('chatNotifications') > -1 && item.title.toLowerCase().indexOf('new message') > -1)) {
          let notify = self.create(item.title, options, item.data.url).subscribe(
            (data: any) => console.log(data), // for handling data
            (error: any) => console.log(error), // for handling error
            () => console.log('completed') // for handling completion
          );
        }
      } else {
        let notify = self.create(item.title, options, item.data.url).subscribe(
          (data: any) => console.log(data), // for handling data
          (error: any) => console.log(error), // for handling error
          () => console.log('completed') // for handling completion
        );
      }
    });

    try {
      if (navigator.setAppBadge) {
        // Just display the badge, with no number in it.
        navigator.setAppBadge(source.length);
      }
    } catch { }
  }
}
export declare type Permission = 'denied' | 'granted' | 'default';
export interface PushNotification {
  body?: string;
  icon?: string;
  tag?: string;
  data?: any;
  renotify?: boolean;
  silent?: boolean;
  sound?: string;
  noscreen?: boolean;
  sticky?: boolean;
  dir?: 'auto' | 'ltr' | 'rtl';
  lang?: string;
  vibrate?: number[];
}
